import axios from "axios";
import { getApiBaseUrl } from "../../config";

const apiPrefix = getApiBaseUrl("auth");

export const authenticateUser = async (credentials) => {
  return await axios.post(`${apiPrefix}/login`, credentials);
};

export const passwordReset = async (formData) => {
  return await axios.post(`${apiPrefix}/api/v1/password-reset`, formData);
};
export const setNewPasswordApi = async (formData) => {
  return await axios.post(`${apiPrefix}/api/v1/set-new-password`, formData);
};
